// @flow
import React, { Component } from 'react'
import Select from './controls/Select'
import AdEditWrapperContainer from './AdEditWrapperContainer'
import { createPortal } from 'react-dom'
import styled from 'styled-components'

type Props = {|
  audienceSelectProperties: Object,
  initiallySelectedAudienceId: number,
  selectedAudienceId: number,
  audienceSelectHtmlId: string,
  adEditWrapperContainerProperties: Object,

  onSelectedAudienceChange: Function
|}

const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 300px;
`

export default class CopyAdToAudience extends Component<Props> {
  constructor(props: Props) {
    super(props)

    const {
      initiallySelectedAudienceId,
      onSelectedAudienceChange,
      audienceSelectProperties
    } = props

    onSelectedAudienceChange &&
      onSelectedAudienceChange(
        initiallySelectedAudienceId,
        audienceSelectProperties.audiencesProviders[initiallySelectedAudienceId]
      )
  }

  render() {
    const { audienceSelectProperties, selectedAudienceId } = this.props
    const el = this.audienceSelectElement()

    return (
      <div>
        {el &&
          createPortal(
            <SelectWrapper className="t-CopyToSelect">
              <Select
                options={[]}
                groupedOptions={audienceSelectProperties.options}
                value={selectedAudienceId}
                onChange={(val) => this.audienceSelectValueChanged(val)}
              />
            </SelectWrapper>,
            el
          )}
        <AdEditWrapperContainer
          {...this.props.adEditWrapperContainerProperties}
          selectedAudienceId={selectedAudienceId}
        />
      </div>
    )
  }

  audienceSelectElement() {
    return document.getElementById(this.props.audienceSelectHtmlId)
  }

  audienceSelectValueChanged(val: string) {
    const { audienceSelectProperties, onSelectedAudienceChange } = this.props
    const selectedId = parseInt(val)

    onSelectedAudienceChange &&
      onSelectedAudienceChange(selectedId, audienceSelectProperties.audiencesProviders[selectedId])
  }
}
